import { useMemo } from "react";

import { useTranslate } from "@similarweb/i18n-provider";

import { useSingleSelectFilterDisplayText } from "../../filters/hooks/useSingleSelectFilterDisplayText";
import { SimpleSingleSelectFilter } from "../../filters/SimpleSingleSelectFilter";

import { trafficTypeTranslationKeyMap } from "./translationKeysConfig";
import { TRAFFIC_TYPES, useSeoAlertsFilterStore } from "./useSeoAlertsFilterStore";

export const TrafficType = () => {
    const { translate } = useTranslate();
    const selectedTrafficType = useSeoAlertsFilterStore((state) => state.selectedTrafficType);
    const setSelectedTrafficType = useSeoAlertsFilterStore((state) => state.setSelectedTrafficType);

    const options = useMemo(
        () =>
            TRAFFIC_TYPES.map((type) => ({
                id: type,
                label: translate(trafficTypeTranslationKeyMap[type]),
            })),
        [translate],
    );

    const trafficTypeDisplayText = useSingleSelectFilterDisplayText({
        defaultSelectionKey: "activation.alerts.filters.traffic-type.all",
        isDefaultSelected: !selectedTrafficType,
        nonDefaultSelectionKey: "activation.alerts.filters.traffic-type.some",
        selectionKey: selectedTrafficType && trafficTypeTranslationKeyMap[selectedTrafficType],
    });

    return (
        <SimpleSingleSelectFilter
            dataAutomation="traffic-type-filter"
            onSelect={setSelectedTrafficType}
            options={options}
            selectedValue={selectedTrafficType}
        >
            {trafficTypeDisplayText}
        </SimpleSingleSelectFilter>
    );
};
